import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivityInterface } from 'src/app/interfaces/activity.interface';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { runtimeEnvironment } from 'src/environments/runtimeEnvironment';
import { SessionService } from '../session/session.service';


@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  private activityUrl: string;
  private token: string;

  constructor(public _http: HttpClient, private _session: SessionService) {
    this.activityUrl = runtimeEnvironment.test ? runtimeEnvironment.test + '/datamaster/businessModels' : `${environment.apiUrl}/datamaster/businessModels`;
    this._session.getTokenSubj$().subscribe((usertoken: string) => {
      if (usertoken) {
        this.token = usertoken;
      }
    });
  }

  public getAllActivities(idBusinessLine: number, filterText: string): Observable<ActivityInterface[]> {
    const reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    let filter: string;
    let observable: Observable<ActivityInterface[]>;
    if (filterText != undefined && filterText != '' && filterText != null && filterText.length > 2) {
      filter = filterText.toString().trim().toLowerCase();
      // tslint:disable-next-line:max-line-length
      observable = this._http.get<ActivityInterface[]>(`${this.activityUrl}/${idBusinessLine}/activities?name=${filter}`, { headers: reqHeader });
    } else {
      observable = this._http.get<ActivityInterface[]>(`${this.activityUrl}/${idBusinessLine}/activities`, { headers: reqHeader });
    }
    return observable;
  }

}

